var styles = {
  "ActionsLayout": "Polaris-ActionMenu-Actions__ActionsLayout"
};

export { styles as default };
